import { render } from "./basic.vue?vue&type=template&id=2ccb1a17"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__